/* Taply — turns the Judge.me featured reviews carousel into a continuous
   marquee and enriches the product mini-card on each review with the
   real product image, title, price, and a clickable "Buy now" link.

   What Judge.me actually renders for each item:
     <a class="jdgm-carousel-item__product" href="/products/HANDLE#judgeme_product_reviews">
       <img class="jdgm-carousel-item__product-image"
            data-src="...25x25.jpg" data-src-retina="...50x50.jpg" />
       <div class="jdgm-carousel-item__product-title">PRODUCT TITLE</div>
     </a>
   Notes:
     - The product image uses lazy-loading via `data-src` / `data-src-retina`,
       so we have to promote those to `src` ourselves.
     - The href already points to the product page; we just clean up the
       Judge.me anchor and fetch /products/HANDLE.js to get the price. */

(function () {
  if (window.__taplyJdgmInit) return;
  window.__taplyJdgmInit = true;

  var priceCache = Object.create(null);

  function formatPrice(price) {
    if (price == null) return '';
    var n = Number(price);
    if (Number.isNaN(n)) return '';
    if (n >= 100) n = n / 100; // Shopify returns cents in /products/handle.js
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function getCheapestPrice(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    var prices = product.variants
      .map(function (v) { return Number(v.price); })
      .filter(function (n) { return !Number.isNaN(n); });
    if (!prices.length) return null;
    return Math.min.apply(null, prices);
  }

  function fetchPrice(handle) {
    if (!handle) return Promise.resolve(null);
    if (priceCache[handle] !== undefined) return Promise.resolve(priceCache[handle]);
    priceCache[handle] = fetch('/products/' + handle + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) { return product ? getCheapestPrice(product) : null; })
      .catch(function () { return null; });
    return priceCache[handle];
  }

  function extractHandle(href) {
    if (!href) return '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function enrichItem(item) {
    if (item.dataset.taplyEnriched === '1') return;
    var productBlock = item.querySelector('.jdgm-carousel-item__product, .jdgm-carousel-item__product-wrapper');
    if (!productBlock) return;

    var href = productBlock.getAttribute('href') || '';
    var handle = extractHandle(href);
    if (!handle) return;

    var img = productBlock.querySelector('.jdgm-carousel-item__product-image');
    if (img) {
      var retina = img.getAttribute('data-src-retina');
      var standard = img.getAttribute('data-src');
      var src = retina || standard;
      if (src && !img.getAttribute('src')) {
        img.setAttribute('src', src);
      }
      if (retina && standard && retina !== standard) {
        img.setAttribute('srcset', standard + ' 1x, ' + retina + ' 2x');
      }
      img.setAttribute('loading', 'lazy');
    }

    // Send users straight to the product page, not the reviews anchor.
    productBlock.setAttribute('href', '/products/' + handle);

    if (!productBlock.querySelector('.taply-jdgm-buy-now')) {
      var cta = document.createElement('div');
      cta.className = 'taply-jdgm-buy-now';
      cta.textContent = 'Shop now \u2192';
      productBlock.appendChild(cta);
    }

    item.dataset.taplyEnriched = '1';

    fetchPrice(handle).then(function (price) {
      if (price == null) return;
      if (productBlock.querySelector('.taply-jdgm-price')) return;
      var priceEl = document.createElement('div');
      priceEl.className = 'taply-jdgm-price';
      priceEl.textContent = formatPrice(price);
      // Insert price BEFORE the buy-now element so display order is title → price → buy.
      var cta = productBlock.querySelector('.taply-jdgm-buy-now');
      if (cta) {
        productBlock.insertBefore(priceEl, cta);
      } else {
        productBlock.appendChild(priceEl);
      }
      // Propagate price to any clones that share the same handle.
      document.querySelectorAll(
        '.jdgm-carousel-item--clone .jdgm-carousel-item__product[href="/products/' + handle + '"], ' +
        '.jdgm-carousel-item--clone .jdgm-carousel-item__product-wrapper[href="/products/' + handle + '"]'
      ).forEach(function (cloneBlock) {
        if (cloneBlock.querySelector('.taply-jdgm-price')) return;
        var clonePriceEl = priceEl.cloneNode(true);
        var cloneCta = cloneBlock.querySelector('.taply-jdgm-buy-now');
        if (cloneCta) {
          cloneBlock.insertBefore(clonePriceEl, cloneCta);
        } else {
          cloneBlock.appendChild(clonePriceEl);
        }
      });
    });
  }

  function process() {
    document.querySelectorAll('.jdgm-carousel__item-wrapper').forEach(function (wrapper) {
      var originals = Array.from(wrapper.children).filter(function (c) {
        return c.classList && c.classList.contains('jdgm-carousel-item') && !c.classList.contains('jdgm-carousel-item--clone');
      });
      if (!originals.length) return;

      originals.forEach(enrichItem);

      if (wrapper.dataset.taplyMarquee !== '1') {
        wrapper.dataset.taplyMarquee = '1';
        originals.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('jdgm-carousel-item--clone');
          wrapper.appendChild(clone);
        });
        var carousel = wrapper.closest('.jdgm-carousel');
        if (carousel) carousel.classList.add('taply-marquee');
        var root = wrapper.closest('.jdgm-carousel-wrapper');
        if (root) root.classList.add('taply-marquee');
      }
    });
  }

  function start() {
    var tries = 0;
    var maxTries = 60;
    function tick() {
      process();
      tries++;
      if (tries < maxTries) setTimeout(tick, 400);
    }
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
